/**
 * Trims whitespace and removes trailing slashes from a URL or base URL string.
 */
function normalizeUrl(url: string): string {
  return url.trim().replace(/\/+$/, "");
}

export { normalizeUrl };
